import { render, staticRenderFns } from "./HasATagMT.vue?vue&type=template&id=db44dd9a&scoped=true&"
import script from "./HasATagMT.vue?vue&type=script&lang=js&"
export * from "./HasATagMT.vue?vue&type=script&lang=js&"
import style0 from "./HasATagMT.vue?vue&type=style&index=0&id=db44dd9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db44dd9a",
  null
  
)

export default component.exports